<template>
  <RisksContentContainerWrapper
    class="pa-3"
    :class="{
      'expand-left': expandLeft,
    }"
    wrapper-id="risks-content-calendarevents"
    :reset-expanded="resetExpanded"
    @click-expand="handleClickExpand"
    @click-collapse="handleClickCollapse"
  >
    <div class="hyp-risk-content-calendarevents-container">
      <div class="details-heading application-heading">
        {{ isCalendarEventsFeatureUnlocked ? eventsLabel : "Elections Watch" }}
        <SimpleDialog
          dialog-class="float-right"
          :show-sidebar="true"
          v-if="calendarMethodology"
        >
          <template v-slot:dialogButton>
            <v-btn
              class="pull-right"
              color="success"
              outlined
              plain
              x-small
              rounded
            >
              <v-icon left x-small>
                fas fa-info-circle
              </v-icon>
              Our Methodology
            </v-btn>
          </template>

          <template>
            <RisksProfileBody
              :profile-info="calendarMethodology"
            ></RisksProfileBody>
          </template>
        </SimpleDialog>
      </div>
      <div class="hyp-risk-content-calendarevents">
        <div
          v-if="!expandedView || !isCalendarEventsCalendarViewFeatureUnlocked"
        >
          <FutureEventsTimelineHolder
            v-if="!isCalendarEventsFeatureUnlocked"
            :openedTimestamp="openedTimestamp"
            :params="params"
          />
          <CalendarEventsTimelineHolder
            v-if="isCalendarEventsFeatureUnlocked"
            :openedTimestamp="openedTimestamp"
            :params="params"
          />
        </div>
        <div v-if="expandedView && isCalendarEventsCalendarViewFeatureUnlocked">
          <CalendarEventsCalendarHolder
            :openedTimestamp="openedTimestamp"
            :params="params"
          />
        </div>
      </div>
    </div>
  </RisksContentContainerWrapper>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import { nowUtc, daysAgo30Utc } from "@/common/date.utilities";
import { LABELS } from "@/common/constants/labels";
import { getCalendarMethodology } from "@/services/common/methodology.service";

export default {
  name: "RisksCalendarEvents",
  components: {
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    FutureEventsTimelineHolder: () =>
      import("@/components/futureEvents/FutureEventsTimelineHolder"),
    CalendarEventsTimelineHolder: () =>
      import("@/components/calendarEvents/CalendarEventsTimelineHolder"),
    CalendarEventsCalendarHolder: () =>
      import("@/components/calendarEvents/CalendarEventsCalendarHolder"),
    RisksProfileBody: () =>
      import("@/components/controlRisks/risks/RisksProfileBody"),
    SimpleDialog: () => import("@/components/common/dialogs/SimpleDialog"),
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
    expandLeft: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      eventsLabel: LABELS.calendarEvents,
      expandedView: false,
      resetExpanded: null,
      openedTimestamp: new Date().toISOString(),
      calendarMethodology: null,
    };
  },
  async mounted() {
    this.calendarMethodology = await getCalendarMethodology();
  },
  computed: {
    isCalendarEventsFeatureUnlocked() {
      return this.featureUnlocked("calendar-events");
    },
    isCalendarEventsCalendarViewFeatureUnlocked() {
      return this.featureUnlocked("calendar-events-calendar-view");
    },
    params() {
      return {
        start: this.isCalendarEventsFeatureUnlocked
          ? new dayjs().startOf("month").startOf("day").toISOString()
          : daysAgo30Utc(),
        end: this.isCalendarEventsFeatureUnlocked
          ? new dayjs().endOf("month").endOf("day").toISOString()
          : nowUtc(),
        aoiId: this.selectedLocation?.selectedCity?.code
          ? this.selectedLocation?.selectedCity?.code
          : this.selectedLocation?.iso2Code?.toUpperCase(),
      };
    },
  },
  methods: {
    handleClickExpand() {
      this.expandedView = true;
    },
    handleClickCollapse() {
      this.expandedView = false;
    },
  },
  watch: {
    selectedLocation: {
      handler() {
        this.resetExpanded = new Date().toISOString();
        this.expandedView = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.hyp-risk-content-calendarevents-container {
  height: 100%;
  width: 100%;
}
.hyp-risk-content-calendarevents {
  overflow-y: scroll;
  height: calc(100% - 30px);
}
>>> .hyp-risk-content-calendarevents .timeline-container {
  overflow-y: auto;
}
.hyp-risks-content-expanded .hyp-risk-content-calendarevents {
  overflow-y: auto !important;
}
</style>
